import Vue from 'vue'
import ContactMixin from 'js/mixins/contact-modal-mixin'
import template from './_help-links.pug'

// @vue/component
export default Vue.extend({
  template: template(),
  mixins: [ContactMixin],

  methods: {
    openLanguageModal() {
      this.$emit('change-language')
    },
    openContactModal() {
      this.$emit('show-contact-modal')
    },
    goToPrivacyPolicy() {
      this.$emit('privacy-policy')
    },
    goToGeneralConditionsOfTransport() {
      this.$emit('general-conditions-of-transport')
    },
    goInstitutionalInformation() {
      this.$emit('institutional-information')
    },
    goTo(destination) {
      this.$emit('go-to', destination)
    }
  }
})
